export default __webpack_public_path__ + "static/openinfra-days-logo-011f8383db38ed9f9233f62004378753.png";